<div class="alert-box">
  <app-icon class="modal-size" color="success" name="checkmark-circle"></app-icon>
  <h2>Success!</h2>
</div>
